// Brand imagery. Cream & gold French-Riviera aesthetic. Afro brand.
export const IMG = {
  heroRiviera: "https://images.pexels.com/photos/16761844/pexels-photo-16761844.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=1920",
  goldSilk: "https://images.unsplash.com/photo-1707569590646-2a51751bb9ef?w=1600",
  travertine: "https://images.unsplash.com/photo-1603323978104-4c1c0d1bfc72?w=1400",
  // Official ÉLANI brand creatives (Afro models, Riviera, on-brand)
  brandHistoire: "https://customer-assets-0z36b82j.emergentagent.net/job_perruque-premium/artifacts/f1sx2epq_PHOTO-2026-07-16-13-06-16%202.jpg",
  brandMonaco: "https://customer-assets-0z36b82j.emergentagent.net/job_perruque-premium/artifacts/zkb90u6h_PHOTO-2026-07-16-13-06-16%203.jpg",
  brandStone: "https://customer-assets-0z36b82j.emergentagent.net/job_perruque-premium/artifacts/bww7yv4w_PHOTO-2026-07-16-13-06-16.jpg",
  brandContact: "https://customer-assets-0z36b82j.emergentagent.net/job_perruque-premium/artifacts/qnnwefa8_c6f582a5-1052-4c5e-ac74-504ed3ace06f.JPG",
  brandGrid: "https://customer-assets-0z36b82j.emergentagent.net/job_perruque-premium/artifacts/hqpez7zy_2e1181d0-0f8b-477b-a020-4fb46ba09ce6.JPG",
  // Generated ÉLANI product/editorial visuals (Afro models)
  silkStraight: "/products/silk_straight.png",
  rivieraWave: "/products/riviera_wave.png",
  wavyPortrait: "/products/wavy_portrait.png",
};

export const CONTACT = {
  whatsapp: "07 76 23 98 44",
  whatsappHref: "https://wa.me/33776239844",
  snapchat: "elanirawhair",
  email: "elanirawhair@gmail.com",
  instagram: "elanirawhair",
  instagramHref: "https://instagram.com/elanirawhair",
};
